import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { constants } from "@qgiv/core-js";
import { TextButton } from "@qgiv/core-donor";
import { useDispatch } from "react-redux";
import { updateCurrentRegistration } from "../../../redux/slices/registrationSlice";
import { setAppShowRemainingForm } from "../../../redux/slices/appSettingsSlice";

const ErrorRedirect = ({
    baseUrl = "",
    localErroredEntities = [],
    totalUnconfirmedRegistrations = [],
    shouldHideForm,
}) => {
    const {
        ENUMS: {
            EntityType: { CLASSIFICATION, TEAM, CATEGORY },
        },
    } = constants;

    const dispatch = useDispatch();
    const [redirectProps, setRedirectProps] = useState({
        pathname: "",
        index: 0,
        runRedirect: false,
    });
    const defaultErrorLinkText =
        "Change your selection to complete your registration.";

    const textButtonStyles =
        "-font-weight--bold -cursor--pointer text-button--color-white text-button--border-bottom";

    // use local state to creating redirect information
    // This useEffect builds Redirect's props
    useEffect(() => {
        if (localErroredEntities.length > 0) {
            // There is a hierarchy to which action should happen first
            // Classification -> Category/Team -> anything else
            const localErroredEntitiesTypes = localErroredEntities.map(
                (erroredEntity) => erroredEntity.entityType,
            );
            if (localErroredEntitiesTypes.includes(Number(CLASSIFICATION))) {
                // has classification
                setRedirectProps({
                    pathname: `${baseUrl}/form/classification`,
                    index: 0,
                    runRedirect: false,
                });
            }

            if (
                localErroredEntitiesTypes.includes(Number(TEAM)) ||
                localErroredEntitiesTypes.includes(Number(CATEGORY))
            ) {
                // redirect to Registration Page with correct currentRegistration state
                setRedirectProps({
                    pathname: `${baseUrl}/form/registration`,
                    // move to the first unconfirmed registration's index in registrations
                    index: totalUnconfirmedRegistrations[0].registrationIndex,
                    runRedirect: false,
                });
            }

            // LEAVE STORE ALONE FOR NOW
            // This can be expanded when taking in new limits
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localErroredEntities]);

    const navigate = useNavigate();

    useEffect(() => {
        if (redirectProps.runRedirect) {
            navigate(
                redirectProps.pathname,
                redirectProps.pathname === `${baseUrl}/form/registration` && {
                    state: {
                        currentRegistration: redirectProps.index,
                    },
                },
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [redirectProps, navigate]);

    // Enable redirect to run
    const handleErrorLinkClick = (e) => {
        e.preventDefault();
        setRedirectProps((prev) => {
            const updatedReturn = {
                ...prev,
                runRedirect: true,
            };
            return updatedReturn;
        });
        dispatch(updateCurrentRegistration(0));
        if (shouldHideForm) {
            dispatch(setAppShowRemainingForm(false));
        }
    };

    return (
        <TextButton
            styles={textButtonStyles}
            handleClick={handleErrorLinkClick}
        >
            {defaultErrorLinkText}
        </TextButton>
    );
};

ErrorRedirect.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    // local state from ErrorDisplay.js which tracks snapshot of erroredEntities
    localErroredEntities: PropTypes.arrayOf(PropTypes.shape({})),
    // Flag to determine when setShowRemainingForm needs to be set to false
    shouldHideForm: PropTypes.bool.isRequired,
    // All unconfirmed registrations in registration[registrations] state
    totalUnconfirmedRegistrations: PropTypes.arrayOf(PropTypes.shape({})),
};

export default ErrorRedirect;
